import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './style.css';
import './dialog.css';
import { authStore } from '@/stores/auth';

await authStore.bootstrap();
createApp(App).use(router).mount('#app');
